import { Box } from '@mui/material';
import React from 'react';

import Loader from '../../Loader/Loader';

interface ITableSkeletonProps {
  height?: number | string;
}

export const TableSkeleton: React.FC<ITableSkeletonProps> = ({ height = 440 }) => {
  return (
    <Box sx={{ position: 'relative', height, width: '100%' }}>
      <Loader lowPriority isLoading={true} style={{ borderRadius: '8px' }} />
    </Box>
  );
};
